import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProductDetailRequestDto } from "../../dtos/get-product-detail-request-dto";
import type { GetProductDetailResponseDto } from "../../dtos/get-product-detail-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetProductDetailQueryParams = {
  queryParams: GetProductDetailRequestDto;
  options?: Omit<UseQueryOptions<GetProductDetailResponseDto>, "queryKey">;
};

export const useGetProductDetailQuery = ({
  queryParams,
  options
}: UseGetProductDetailQueryParams) => {
  return useQuery({
    queryKey: ProductQueryKeys.getProductDetail({ ...queryParams }).queryKey,
    queryFn: async () =>
      await ProductService.getProductDetail({ payload: queryParams }),
    ...options
  });
};
